/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

import { TenantGrant } from "../models/http/tenant/tenant-grant.model";

export const GRANTS = {
	regionalEmissions: {
		tab: "re:tab",
		averageCarbonIntensityByRegion: "re:widget:averageCarbonIntensityByRegion",
		carbonIntensityByCountry: "re:widget:carbonIntensityByCountry"
	},
	impact: {
		tab: "impact:tab",
		totalCo2Emissions: "impact:widget:totalCo2Emissions",
		totalEmissionsBreakdownByDomain: "impact:widget:totalEmissionsBreakdownByDomain",
		totalEmissionsBreakdownByScope: "impact:widget:totalEmissionsBreakdownByScope",
		trend: "impact:widget:trend",
		detail: "impact:widget:detail"
	},
	swabl: {
		tab: "swabl:tab",
		totalApplicationsCarbonFootprint: "swabl:widget:totalApplicationsCarbonFootprint",
		totalApplications: "swabl:widget:totalApplications",
		totalEmissionsByApplications: "swabl:widget:totalEmissionsByApplications",
		emissionBreakdownByHostingType: "swabl:widget:emissionBreakdownByHostingType",
		emissionBreakdownByScope: "swabl:widget:emissionBreakdownByScope",
		top10EmissionsBreakdown: "swabl:widget:top10EmissionsBreakdown",
		totalApplicationsEmissions: "swabl:widget:totalApplicationsEmissions"
	},
	swart: {
		tab: "swart:tab",
		totalCo2Emissions: "swart:widget:totalCo2Emissions",
		myRunningApps: "swart:widget:MyRunningApps",
		totalApplicationEmissions: "swart:widget:totalApplicationEmissions",
		environmentalImpactApps: "swart:widget:EnvironmentalImpactApps",
		environmentalImpactLayersPerApp: "swart:widget:EnvironmentalImpactLayersPerApp",
		componentEmissionsEmbodiedEmissionsByApp:
			"swart:widget:ComponentEmissionsEmbodiedEmissionsByApp",
		componentEmissionsTimeseries: "swart:widget:ComponentEmissionsTimeseries",
		softwareCarbonIntensitySciScoreOfTheApps:
			"swart:widget:SoftwareCarbonIntensitySciScoreOfTheApps",
		softwareCarbonIntensityApplicationEfficiency:
			"swart:widget:SoftwareCarbonIntensityApplicationEfficiency",
		energyConsumptionTotalEnergyConsumption:
			"swart:widget:EnergyConsumptionTotalEnergyConsumption",
		energyConsumptionMyRunningApps: "swart:widget:EnergyConsumptionMyRunningApps",
		energyConsumptionTop10Apps: "swart:widget:EnergyConsumptionTop10Apps",
		energyConsumptionTop10Layers: "swart:widget:EnergyConsumptionTop10Layers"
	},
	cloud: {
		tab: "cloud:tab",
		totalCo2Emissions: "cloud:widget:totalCo2Emissions",
		myCloudProviders: "cloud:widget:myCloudProviders",
		cloudProvidersEmissions: "cloud:widget:cloudProvidersEmissions",
		environmentalImpactApplications: "cloud:widget:environmentalImpactApplications",
		environmentalImpactRegions: "cloud:widget:environmentalImpactRegions",
		applicationsPercentageView: "cloud:widget:applicationsPercentageView",
		applicationsTrueValueView: "cloud:widget:applicationsTrueValueView",
		locationsPercentageView: "cloud:widget:locationsPercentageView",
		// Assumed: the Excel lists applicationsTrueValueView twice.
		locationsTrueValueView: "cloud:widget:locationsTrueValueView"
	},
	hwabl: {
		tab: "hwabl:tab",
		totalEmission: "hwabl:widget:totalEmission",
		scope2Emission: "hwabl:widget:scope2Emission",
		scope3Emission: "hwabl:widget:scope3Emission",
		totalAssetsCount: "hwabl:widget:totalAssetsCount",
		manufacturerCount: "hwabl:widget:manufacturerCount",
		totalCo2OverTime: "hwabl:widget:totalCO2overTime",
		totalEmissionByManufacturer: "hwabl:widget:totalEmissionByManufacturer",
		carbonFootprintByDeviceCategory: "hwabl:widget:carbonFootprintByDeviceCategory",
		carbonFootprintScopeBreakdownPercentageView:
			"hwabl:widget:carbonFootprintScopeBreakdownPercentageView",
		carbonFootprintScopeBreakdownTrueValueView:
			"hwabl:widget:carbonFootprintScopeBreakdownTrueValueView",
		operationalCo2ByModel: "hwabl:widget:operationalCo2ByModel",
		topCountriesByTotalCo2Emissions: "hwabl:widget:topCountriesByTotalCO2emissions",
		operationalCo2ByDeviceStatus: "hwabl:widget:operationalCO2byDeviceStatus",
		emissionsReductionAchievedByLifecycleExtension:
			"hwabl:widget:emissionsReductionAchievedByLifecycleExtension",
		operationalCo2ByCountry: "hwabl:widget:operationalCO2ByCountry"
	},
	hwart: {
		tab: "hwart:tab",
		totalCo2Emissions: "hwart:widget:totalCO2emissions",
		operationalEmissions: "hwart:widget:operationalEmissions",
		embodiedEmissions: "hwart:widget:embodiedEmissions",
		totalEmissionsOverTime: "hwart:widget:totalEmissionsOverTime",
		deviceAnalysisModels: "hwart:widget:deviceAnalysisModels",
		deviceAnalysisTotalEmissionByManufacturer:
			"hwart:widget:deviceAnalysisTotalEmissionByManufacturer",
		locationsGeographicAnalysis: "hwart:widget:locationsGeographicAnalysis",
		locationsPerDeviceEmissionsByLocation: "hwart:widget:locationsPerDeviceEmissionsByLocation",
		locationsTotalEmissionsByLocation: "hwart:widget:locationsTotalEmissionsByLocation",
		locationsTotalOverTimePerLocation: "hwart:widget:locationsTotalOverTimePerLocation",
		embodiedEmissionsSavedLifecycleEmissions:
			"hwart:widget:embodiedEmissionsSavedLifecycleEmissions"
	},
	dc: {
		tab: "dc:tab",
		overview: "dc:widget:overview",
		summary: "dc:widget:summary",
		efficiencyMetrics: "dc:widget:efficiencyMetrics",
		keyMetrics: "dc:widget:keyMetrics",
		energyConsumptionAndEmissions: "dc:widget:energyConsumptionAndEmissions",
		energyBreakdown: "dc:widget:energyBreakdown"
	},
	ai: {
		tab: "ai:tab",
		co2Kpi: "ai:widget:CO2KPI",
		waterUsageKpi: "ai:widget:waterUsageKPI",
		totalAppsKpi: "ai:widget:totalAppsKPI",
		emissionsByApplication: "ai:widget:emissionsByApplication",
		waterByApplication: "ai:widget:waterByApplication",
		modelImpacts: "ai:widget:modelImpacts",
		emissionsByCompany: "ai:widget:emissionsByCompany",
		emissionsByModel: "ai:widget:emissionsByModel",
		waterUsageByModel: "ai:widget:waterUsageByModel",
		mostEfficientModelCo2: "ai:widget:mostEfficientModelCO2",
		mostEfficientModelWater: "ai:widget:mostEfficientModelWater"
	},
	toolbox: {
		tab: "toolbox:tab",
		whatIf: "toolbox:widget:whatIf",
		calculator: "toolbox:widget:calculator",
		anomaliesDetection: "toolbox:widget:anomaliesDetection"
	}
} as const satisfies Record<string, Record<string, TenantGrant>>;

export const ALL_GRANTS: TenantGrant[] = Object.values(GRANTS).flatMap(page => Object.values(page));
